import { createHashRouter, Navigate } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { AuthPage } from "../pages/AuthPage";
import { AreaPage } from "../pages/AreaPage";
import { AreasPage } from "../pages/AreasPage";
import { ListPage } from "../pages/ListPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { ProjectPage } from "../pages/ProjectPage";
import { ProjectsPage } from "../pages/ProjectsPage";
import { RepeatingPage } from "../pages/RepeatingPage";
import { SearchPage } from "../pages/SearchPage";
import { SettingsPage } from "../pages/SettingsPage";
import { SomedayPage } from "../pages/SomedayPage";
import { TagPage } from "../pages/TagPage";
import { UpcomingPage } from "../pages/UpcomingPage";
import { TaskDetailsPage } from "../pages/TaskDetailsPage";
import { SavedViewsPage } from "../pages/SavedViewsPage";
import { OfflinePage } from "../pages/OfflinePage";
import { RetiredFeaturePage } from "../pages/RetiredFeaturePage";
import { OverviewPage } from "../pages/OverviewPage";
import { AnonymousOnlyRoute, ProtectedRoute } from "../auth/AuthGate";
import { RouteErrorPage } from "../pages/RouteErrorPage";

export const router = createHashRouter([
  { path: "/welcome", element: <Navigate to="/login" replace /> },
  { path: "/login", errorElement: <RouteErrorPage />, element: <AnonymousOnlyRoute><AuthPage mode="login" /></AnonymousOnlyRoute> },
  { path: "/signup", errorElement: <RouteErrorPage />, element: <AnonymousOnlyRoute><AuthPage mode="signup" /></AnonymousOnlyRoute> },
  { path: "/forgot-password", errorElement: <RouteErrorPage />, element: <AnonymousOnlyRoute><AuthPage mode="forgot" /></AnonymousOnlyRoute> },
  { path: "/reset-password", errorElement: <RouteErrorPage />, element: <AuthPage mode="reset" /> },
  {
    path: "/",
    errorElement: <RouteErrorPage />,
    element: <ProtectedRoute><AppShell /></ProtectedRoute>,
    children: [
      { index: true, element: <Navigate to="today" replace /> },
      { path: "overview", element: <OverviewPage /> },
      { path: "inbox", element: <ListPage view="inbox" /> },
      { path: "today", element: <ListPage view="today" /> },
      { path: "upcoming", element: <UpcomingPage /> },
      { path: "anytime", element: <ListPage view="anytime" /> },
      { path: "someday", element: <SomedayPage /> },
      { path: "deadlines", element: <ListPage view="deadlines" /> },
      { path: "repeating", element: <RepeatingPage /> },
      { path: "logbook", element: <ListPage view="logbook" /> },
      { path: "projects", element: <ProjectsPage /> },
      { path: "projects/:projectId", element: <ProjectPage /> },
      { path: "tasks/:taskId", element: <TaskDetailsPage /> },
      { path: "areas", element: <AreasPage /> },
      { path: "areas/:areaId", element: <AreaPage /> },
      { path: "tags/:tagId", element: <TagPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "review", element: <RetiredFeaturePage destination="/today" destinationLabel="Go to Today" /> },
      { path: "views", element: <SavedViewsPage /> },
      { path: "calendar", element: <RetiredFeaturePage destination="/today" destinationLabel="Go to Today" /> },
      { path: "offline", element: <OfflinePage /> },
      { path: "capture", element: <RetiredFeaturePage destination="/inbox" destinationLabel="Go to Inbox" /> },
      { path: "settings/notifications", element: <RetiredFeaturePage destination="/settings/general" destinationLabel="Go to Settings" /> },
      { path: "settings/:section", element: <SettingsPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
